// Module
var code = `<div role="button" class="svc-preview__test-again svc-btn" data-bind="click: testAgainAction.action, key2click, clickBubble: false">
  <span class="svc-btn__text" data-bind="text: testAgainAction.title">
  </span>
</div>`;
// Exports
export default code;